import {
  LinkObfuscated,
  LinkObfuscatedProps,
} from 'libs/growth-platform-brand-system-v2/src/utils/obfuscation/LinkObfuscated';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import React from 'react';

function ExternalLink({
  href,
  target = '_blank',
  className,
  onMouseEnter,
  onMouseLeave,
  section,
  index,
  title,
  children,
  obfuscationActivated = false,
  ...props
}: Omit<LinkObfuscatedProps, 'target'> & {
  target?: '_self' | '_blank';
  obfuscationActivated: boolean;
  section?: string;
  index?: number;
  title?: string;
}) {
  if (!href || href === '#') {
    return (
      <span
        className={className}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </span>
    );
  }
  if (href && obfuscationActivated) {
    return (
      <ButtonTracking
        {...props}
        component={LinkObfuscated}
        section={section}
        labelTracking={title}
        index={index}
        href={href}
        blank={target === '_blank'}
        className={className}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </ButtonTracking>
    );
  }
  return (
    <ButtonTracking
      {...props}
      component={'a'}
      section={section}
      labelTracking={title}
      index={index}
      href={href}
      target={'_blank'}
      rel="noreferrer"
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </ButtonTracking>
  );
}

export default ExternalLink;
